export const ACTIVITY_TYPES = [
  {
    id: "unknown",
    label: "Activity",
    symbol: "type_unknown",
  },
  {
    id: "biking",
    label: "Biking",
    symbol: "type_biking",
    aliases: [
      "cycling",
      "mountain_biking",
      "e-biking",
      "gravel riding",
      "road_cycling",
      "bike tour",
      "cycle tour",
      // Include common variations directly here
      "road bike",
      "mountain bike",
      "gravel bike",
      "e-bike",
      "indoor cycling",
      "virtual ride",
      "velomobile",
    ],
  },
  {
    id: "hiking",
    label: "Hiking",
    symbol: "type_hiking",
    aliases: [
      "hiking", // Keep for direct match
      "hikingtourtrail",
      "longDistanceHikingTrail",
      "longdistancehikingtrail",
      "snowshoe",
      "trekking",
      "hike", // Add common shorter variations
    ],
  },
  {
    id: "walking",
    label: "Walking",
    symbol: "type_walking",
    aliases: ["walk", "walking", "nordic walking"],
  },
  {
    id: "running",
    label: "Running",
    symbol: "type_running",
    aliases: [
      "trail_run",
      "treadmill_running",
      "track_run",
      "ultra_run",
      "race",
      "long_run",
      "virtual_run",
      "run", // Add common shorter variations
      "workout", // As you noted, often includes running intervals
    ],
  },
  {
    id: "climbing",
    label: "Climbing",
    symbol: "type_climbing",
    aliases: [
      "mountaineering",
      "climb",
      "rock climb",
      "indoor climbing",
      "bouldering",
      "alpine climbing",
      "ice climbing",
      "via_ferrata",
      "climbing", // Keep for direct match
    ],
  },
  {
    id: "swimming",
    label: "Swimming",
    symbol: "type_swimming",
    aliases: ["swim", "pool swim", "open water swim", "swimming"], // Keep for direct match
  },
  {
    id: "skiing",
    label: "Skiing",
    symbol: "type_skiing",
    aliases: [
      "ski",
      "alpine ski",
      "downhill skiing",
      "cross-country ski",
      "nordic ski",
      "backcountry ski",
      "ski touring",
      "snowboard",
      "telemark skiing",
      "skiing", // Keep for direct match
    ],
  },
  {
    id: "diving",
    label: "Diving",
    symbol: "type_diving",
    aliases: ["diving", "snorkeling"],
  },
  {
    id: "sailing",
    label: "Sailing",
    symbol: "type_sailing",
    aliases: ["sail", "sailing"],
  },
  {
    id: "kayaking",
    label: "Kayak",
    symbol: "type_kayaking",
    aliases: [
      "kayak",
      "row",
      "stand up paddleboarding",
      "sup",
      "canoe",
      "white water rafting",
      "kayaking", // Add common variations
      "rowing",
      "canoeing",
    ],
  },
  {
    id: "surfing",
    label: "surfing",
    symbol: "type_surfing",
    aliases: [
      "windsurf",
      "surf",
      "kitesurf",
      "wakeboard",
      "windsurfing",
      "surfing",
      "kite surfing",
      "wake boarding",
    ],
  },
];

export default ACTIVITY_TYPES;

// --- Optimized TRACK_CLASSIFICATION_MAPPING generation ---
export const TRACK_CLASSIFICATION_MAPPING = {};

ACTIVITY_TYPES.forEach((activity) => {
  // Add the main ID itself to the mapping
  if (activity.id !== "unknown") {
    // 'unknown' shouldn't be a direct mapping key
    TRACK_CLASSIFICATION_MAPPING[activity.id] = activity.id;
  }

  // Add all aliases to the mapping, pointing back to the main ID
  activity.aliases?.forEach((alias) => {
    TRACK_CLASSIFICATION_MAPPING[alias.toLowerCase()] = activity.id; // Ensure aliases are lowercase for consistency
  });
});

// We can add specific overrides or additions if needed, but in most cases,
// deriving from ACTIVITY_TYPES should cover it.
// Example: if "workout" is sometimes not a "running" type, you might have to adjust.
// TRACK_CLASSIFICATION_MAPPING["workout"] = "running"; // If not already in aliases

// --- Optimized getActivityDetails function ---
export const getActivityDetails = (activityTypeFromGpx) => {

  if (!activityTypeFromGpx) {
    return ACTIVITY_TYPES.find((activity) => activity.id === "unknown");
  }

  const lowercasedGpxType = activityTypeFromGpx.toLowerCase();
  const normalizedActivityId = TRACK_CLASSIFICATION_MAPPING[lowercasedGpxType];

  if (normalizedActivityId) {
    const foundActivity = ACTIVITY_TYPES.find(
      (activity) => activity.id === normalizedActivityId
    );
    // This should always find an activity if normalizedActivityId is valid,
    // but a defensive check is good practice.
    if (foundActivity) {
      return foundActivity;
    }
  }

  // Fallback to "unknown" if not found
  return ACTIVITY_TYPES.find((activity) => activity.id === "unknown");
};
